import { useEffect, useState } from 'react'
import { useInstance, usePublish, useUpdateEffect, useView } from '@10000/react'
import { Stack, useShell, useStack } from '../../layout'
import { ConfirmExit } from '../common'
import { Box, Button, QR } from '../../widgets'
import { Analytics, Consensus, Exited, Waiting, Results, Splash, TeamAverage } from '.'
import { Recap, Splash as RecapSplash } from '../recap'
import { Tutorial } from '../setup'
import { RegisterSplash } from '../../kiosk'
import { preload } from './preload.js'

export const Display = ({ active }) => {
  const { qrVisible, questionIndex, stage, result, teamAverages, options: { questionCount, kiosk } } = useView('squiz')
  const { id, region } = useInstance()
  const firstQuestion = teamAverages.every(x => x === null)

  useShell({ active, mode: 'logo' })
  useEffect(() => { preload() }, [])

  return (
    <Box column fullHeight fullWidth maxHeight="100%" overflow="hidden">
      <Stack
        initialStack={[{ Component: getComponent(questionIndex, stage, result, questionCount, firstQuestion, true), props: { displayMode: true } }]}
        limitHeight={false}
      >
        <Controller />

        <Box position="fixed" bottom={20} left={20} opacity={qrVisible ? 1 : 0} transition={0.5} zIndex={100}>
          <QR size={400} instanceId={id} region={region} />
        </Box>

        {kiosk && <EndSquizButton />}
      </Stack>
    </Box>
  )
}

function getComponent(questionIndex, stage, result, questionCount, firstQuestion, initial) {
  return questionIndex === -1 ? Splash
    : stage === 'exited' ? Exited
    : stage === 'analytics' ? Analytics
    : stage === 'register' ? RegisterSplash
    : questionIndex === questionCount
      ? initial ? Recap : RecapSplash
    : (stage === 'tutorial' || stage === 'consensus-tutorial' || stage === 'results-tutorial') ? Tutorial
    : stage === 'results' ? Results
    : stage === 'consensus' ? Consensus
    : stage === 'question-option'
      ? firstQuestion && Waiting
    : TeamAverage
}

const Controller = () => {
  const { replaceStack } = useStack()
  const { questionIndex, stage, result, teamAverages, options: { questionCount } } = useView('squiz')
  const firstQuestion = teamAverages.every(x => x === null)

  useUpdateEffect(() => {
    if(!result || result.startsWith('teamAverage') || stage === 'analytics') { // flaky as fuck and duplicated in Host
      const component = getComponent(questionIndex, stage, result, questionCount, firstQuestion, false)
      if(component) {
        replaceStack(component, { props: { displayMode: true } })
      }
    }
  }, [replaceStack, questionIndex, stage, result, questionCount])

  return null
}

const EndSquizButton = () => {
  const publish = usePublish('squiz')
  const [confirmExit, setConfirmExit] = useState(false)

  const end = e => {
    setConfirmExit(false)
    publish('squizExited')
    e.stopPropagation()
  }

  return <>
    <Box position="fixed" top={20} right={40} zIndex={10}>
      <Button light onClick={() => setConfirmExit(true)}>
        End Squiz
      </Button>
    </Box>
    <ConfirmExit
      open={confirmExit}
      onCancel={() => setConfirmExit(false)}
      onConfirm={end}
    />
  </>
}